<template>
  <div v-show="isVisible">
    <bm-form ref="form" lazy-validation>
      <slot />
    </bm-form>
  </div>
</template>

<script lang="ts">
import BmForm from "@/components/controls/BmForm.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmWizardStep",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    optional: {
      type: Boolean,
      required: true,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isVisible: false as boolean,
    };
  },
  watch: {
    isVisible: {
      // @ts-ignore
      handler: "visibilityChanged",
      immediate: true,
    },
  },
  methods: {
    validate(): boolean {
      const forms = this.$children.filter(
        (c) => c.$options.name === BmForm.name
      );
      return !forms.some(function (form: any) {
        return !form.validate();
      });
    },
    visibilityChanged() {
      if (this.isVisible && this.$refs.form) {
        (this.$refs.form as any).focus();
      }
    },
  },
});
</script>
